module.exports = __webpack_public_path__ + "20260831_v3.3.0/img/floating-point-icon.91a48424.png";